import './App.css';
import React, { useState } from "react";
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import { thunk } from 'redux-thunk';
import rootReducer from './reducers';
import Login from "./views/Login/Login";
import ForgotPassword from "./views/ForgotPassword/ForgotPassword";
import ValidationCode from "./views/ValidationCode/ValidationCode";
import ResetPassword from "./views/ForgotPassword/ResetPassword";
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import PasswordChangeGuard from './components/PasswordChangeGuard';
import SinistreSection from './components/sinistreSection/sinistreSection';
import TaskInformation from './components/TaskListSection/TaskInformation';
import DesignateParties from './components/TaskListSection/DynamicComponentTodoList/DesignateParties';
import PaymentParties from './components/TaskListSection/DynamicComponentTodoList/PaymentParties';
import InvoiceValidation from './components/TaskListSection/DynamicComponentTodoList/InvoiceValidation';
import ReparationMissionAcceptance from './components/TaskListSection/DynamicComponentTodoList/ReparationMissionAcceptance';
import ServiceProposal from './components/TaskListSection/DynamicComponentTodoList/ServiceProposal';
import UploadQuotation_invoices from './components/TaskListSection/DynamicComponentTodoList/UploadQuotation_invoices';
import CaculateClientPartPayment from './components/TaskListSection/DynamicComponentTodoList/CaculateClientPartPayment';
import MakeIneligible from './components/TaskListSection/DynamicComponentTodoList/MakeIneligible';
import Layout from './components/Layout/Layout';
import Sinistres from './views/Sinistres/Sinistres';
import Regulations from './views/Payment/Payment';
import Polices from './views/Polices/Polices';
import Planning from './views/Planning/Planning';
import ReplacementCar from './views/ReplacementCar/ReplacementCar';
import Applications from './views/Applications/Applications';
import ListSettlementEligibleClaim from './views/EligibleClaim/ListSettlementEligibleClaim';
import ListClaimToBeLoadedToPlatform from './views/ListClaimToBeLoadedToPlatform/ListClaimToBeLoadedToPlatform';
import TaskList from './views/TaskList/TaskList';
import ClientPartPayment from './components/TaskListSection/DynamicComponentTodoList/ClientPartPayment';
import ClientPartPaymentPartner from './components/TaskListSection/DynamicComponentTodoList/ClientPartPaymentPartner';
import UploadInvoiceAndPictures from './components/TaskListSection/DynamicComponentTodoList/UploadInvoiceAndPictures'
import ReparationEntryDateIndication
    from "./components/TaskListSection/DynamicComponentTodoList/ReparationEntryDateIndication";
import Expertises from "./views/Expertises/Expertises";
import CarExitVoucher from './components/TaskListSection/DynamicComponentTodoList/CarExitVoucher';
import SendRepairShopPayment from './components/TaskListSection/DynamicComponentTodoList/SendRepairShopPayment';
import Dashboard from "./views/Dashboard/Dashboard";
import ChangePassword from "./views/ChangePassword/ChangePassword";
import CustomerNumTel from './components/TaskListSection/DynamicComponentTodoList/CustomerNumTel';
import ReparationMissionList from './views/ReparationMission/ReparationMission';
import AgenciesReference from "./views/AgenciesReference/AgenciesReference";
import UserGroups from './views/Admin/UserGroups/UserGroups';
import Users from './views/Admin/Users/User';
import Experts from './views/Admin/Expert/expert';
import Services from './views/Admin/Services/services';
import Repairers from './views/Repairer/Repairer'
import { ToastContainer } from 'react-toastify';
import Investigation from "./views/Investigation/Investigation";
import InspectorShifts from "./views/InspectorShifts/InspectorShifts";
import UploadQuittance from './components/TaskListSection/DynamicComponentTodoList/UploadQuittance';
import UploadPictureBeforeRep from './components/TaskListSection/DynamicComponentTodoList/UploadPictureBeforeRep';
import UploadPicturesAndReport from './components/TaskListSection/DynamicComponentTodoList/UploadPicuresAndReport';

const middlewares = [thunk];
const middlewareEnhancer = applyMiddleware(...middlewares);
const enhancers = [middlewareEnhancer];
const composedEnhancers = compose(...enhancers);
const store = createStore(rootReducer, undefined, composedEnhancers);

function App() {
    const [indexRoute, setIndexRoute] = useState('Applications');
    const [idClaim, setIdClaim] = useState(null);
    const [taskId, setTaskId] = useState(null);

    const ProtectedLayout = ({ children }) => (
        <PrivateRoute>
            <PasswordChangeGuard>
                <Layout 
                    indexRoute={indexRoute} 
                    setIndexRoute={setIndexRoute} 
                    setIdClaim={setIdClaim} 
                    setTaskId={setTaskId}
                >
                    {children}
                </Layout>
            </PasswordChangeGuard>
        </PrivateRoute>
    );

    return (
        <Provider store={store}>
            <Router basename="/maeassurance">
                <ToastContainer
                    position="bottom-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="colored"
                />

                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/validation-code" element={<ValidationCode />} />
                    <Route
                        path="/dashboard"
                        element={
                            <ProtectedLayout>
                                <Dashboard />
                            </ProtectedLayout>
                        }
                    />
                    <Route
                        path="/changer-mot-de-passe"
                        element={
                            <ProtectedLayout>
                                <ChangePassword />
                            </ProtectedLayout>
                        }
                    />

                    <Route
                        path="/applications"
                        element={
                            <ProtectedLayout>
                                <Applications />
                            </ProtectedLayout>
                        }
                    />
                    {/** commented: not in allowed app routes **/}
                    {/**
                    <Route
                        path="/applications"
                        element={
                            <ProtectedLayout>
                                <Applications />
                            </ProtectedLayout>
                        }
                    />
                    */}

                    {/**
                    <Route
                        path="/policessss"
                        element={
                            <ProtectedLayout>
                                <Polices />
                            </ProtectedLayout>
                        }
                    />
                    */}

                    <Route
                        path="/sinistres"
                        element={
                            <ProtectedLayout>
                                <Sinistres setIndexRoute={setIndexRoute} setIdClaim={setIdClaim} />
                            </ProtectedLayout>
                        }
                    />

                    {/**
                    <Route
                        path="/payment"
                        element={
                            <ProtectedLayout>
                                <Regulations setIndexRoute={setIndexRoute} setIdClaim={setIdClaim} />
                            </ProtectedLayout>
                        }
                    />
                    */}

                    {/**
                    <Route
                        path="/planning"
                        element={
                            <ProtectedLayout>
                                <Planning setIndexRoute={setIndexRoute} setIdClaim={setIdClaim} />
                            </ProtectedLayout>
                        }
                    />
                    */}

                    {/**
                    <Route
                        path="/expertises"
                        element={
                            <ProtectedLayout>
                                <Expertises setIndexRoute={setIndexRoute} setIdClaim={setIdClaim} />
                            </ProtectedLayout>
                        }
                    />
                    */}

                    <Route
                        path="/sinistre/:idClaim"
                        element={
                            <ProtectedLayout>
                                <SinistreSection idClaim={idClaim} />
                            </ProtectedLayout>
                        }
                    />

                    {/**
                    <Route
                        path="/SettlementEligibleClaim"
                        element={
                            <ProtectedLayout>
                                <ListSettlementEligibleClaim  setIndexRoute={setIndexRoute} setTaskId={setTaskId}/>
                            </ProtectedLayout>
                        }
                    />
                    */}

                    {/**
                    <Route
                        path="/ClaimToBeLoadedToPlatform"
                        element={
                            <ProtectedLayout>
                                <ListClaimToBeLoadedToPlatform  setIndexRoute={setIndexRoute} setTaskId={setTaskId}/>
                            </ProtectedLayout>
                        }
                    />
                    */}

                    {/**
                    <Route
                        path="/make_Ineligible/:taskId"
                        element={
                            <ProtectedLayout>
                                <MakeIneligible taskId={taskId} />
                            </ProtectedLayout>
                        }
                    />
                    */}

                    <Route
                        path="/todo-list"
                        element={
                            <ProtectedLayout>
                                <TaskList setIndexRoute={setIndexRoute} setTaskId={setTaskId} />
                            </ProtectedLayout>
                        }
                    />

                    <Route
                        path="/todo-list/:taskId"
                        element={
                            <ProtectedLayout>
                                <TaskInformation taskId={taskId} />
                            </ProtectedLayout>
                        }
                    />

                    <Route
                        path="/designate-parties/:taskId"
                        element={
                            <ProtectedLayout>
                                <DesignateParties/>
                            </ProtectedLayout>
                        }
                    />

                    <Route
                        path="/confirm_payment/:taskId"
                        element={
                            <ProtectedLayout>
                                <PaymentParties taskId={taskId} />
                            </ProtectedLayout>
                        }
                    />

                    <Route
                        path="/invoice-validation/:taskId"
                        element={
                            <ProtectedLayout>
                                <InvoiceValidation taskId={taskId} />
                            </ProtectedLayout>
                        }
                    />

                    <Route
                        path="/reparation-mission-acceptance/:taskId"
                        element={
                            <ProtectedLayout>
                                <ReparationMissionAcceptance/>
                            </ProtectedLayout>
                        }
                    />

                    <Route
                        path="/service-proposal/:taskId"
                        element={
                            <ProtectedLayout>
                                <ServiceProposal/>
                            </ProtectedLayout>
                        }
                    />

                    <Route
                        path="/customer-num-tel/:taskId"
                        element={
                            <ProtectedLayout>
                                <CustomerNumTel taskId={taskId} />
                            </ProtectedLayout>
                        }
                    />

                    <Route
                        path="/upload-quotation-invoices/:taskId"
                        element={
                            <ProtectedLayout>
                                <UploadQuotation_invoices/>
                            </ProtectedLayout>
                        }
                    />

                    <Route
                        path="/client-part-payment/:taskId"
                        element={
                            <ProtectedLayout>
                                <ClientPartPayment/>
                            </ProtectedLayout>
                        }
                    />

                    <Route
                        path="/client-part-payment-partner/:taskId"
                        element={
                            <ProtectedLayout>
                                <ClientPartPaymentPartner/>
                            </ProtectedLayout>
                        }
                    />

                    <Route
                        path="/client-part-payment-calculation/:taskId"
                        element={
                            <ProtectedLayout>
                                <CaculateClientPartPayment taskId={taskId} />
                            </ProtectedLayout>
                        }
                    />

                    <Route
                        path="/upload-invoice-and-pictures/:taskId"
                        element={
                            <ProtectedLayout>
                                <UploadInvoiceAndPictures/>
                            </ProtectedLayout>
                        }
                    />

                    <Route
                        path="/reparation-entry-date-indication/:taskId"
                        element={
                            <ProtectedLayout>
                                <ReparationEntryDateIndication/>
                            </ProtectedLayout>
                        }
                    />

                    {/**
                    <Route
                        path="/voiture_de_remplacement"
                        element={
                            <ProtectedLayout>
                                <ReplacementCar setIndexRoute={setIndexRoute}  />
                            </ProtectedLayout>
                        }
                    />
                    */}

                    {/**
                    <Route
                        path="/reparation_mission_list"
                        element={
                            <ProtectedLayout>
                                <ReparationMissionList setIndexRoute={setIndexRoute}  />
                            </ProtectedLayout>
                        }
                    />
                    */}

                    <Route
                        path="/car-exit-voucher-generation/:taskId"
                        element={
                            <ProtectedLayout>
                                <CarExitVoucher/>
                            </ProtectedLayout>
                        }
                    />

                    <Route
                        path="/send-RepairShop-payment/:taskId"
                        element={
                            <ProtectedLayout>
                                <SendRepairShopPayment/>
                            </ProtectedLayout>
                        }
                    />

                    <Route
                        path="/user-groups"
                        element={
                            <ProtectedLayout>
                                <UserGroups/>
                            </ProtectedLayout>
                        }
                    />

                    <Route
                        path="/users"
                        element={
                            <ProtectedLayout>
                                <Users/>
                            </ProtectedLayout>
                        }
                    />

                    <Route
                        path="/experts"
                        element={
                            <ProtectedLayout>
                                <Experts/>
                            </ProtectedLayout>
                        }
                    />

                    {/**
                    <Route
                        path="/services"
                        element={
                            <ProtectedLayout>
                                <Services/>
                            </ProtectedLayout>
                        }
                    />
                    */}

                    <Route
                        path="/agencies-reference"
                        element={
                            <ProtectedLayout>
                                <AgenciesReference setIndexRoute={setIndexRoute}  />
                            </ProtectedLayout>
                        }
                    />

                    {/**
                    <Route
                        path="/repairers"
                        element={
                            <ProtectedLayout>
                                <Repairers/>
                            </ProtectedLayout>
                        }
                    />
                    */}

                    {/**
                    <Route
                        path="/investigations"
                        element={
                            <ProtectedLayout>
                                <Investigation/>
                            </ProtectedLayout>
                        }
                    />
                    */}

                    {/**
                    <Route
                        path="/inspector-shifts"
                        element={
                            <ProtectedLayout>
                                <InspectorShifts/>
                            </ProtectedLayout>
                        }
                    />
                    */}

                    <Route
                        path="/upload-quittance/:taskId"
                        element={
                            <ProtectedLayout>
                                <UploadQuittance/>
                            </ProtectedLayout>
                        }
                    />

                    <Route
                        path="/upload-pictures-before-repair/:taskId"
                        element={
                            <ProtectedLayout>
                                <UploadPictureBeforeRep/>
                            </ProtectedLayout>
                        }
                    />

                    <Route
                        path="/upload-pictures-and-report/:taskId"
                        element={
                            <ProtectedLayout>
                                <UploadPicturesAndReport/>
                            </ProtectedLayout>
                        }
                    />

                    <Route path="/" element={<Navigate to="/login" />} />
                </Routes>
            </Router>
        </Provider>
    );
}

export default App;